<div class="cart-overlay" [class.open]="cartService.isOpen()" (click)="close()"></div>

<div class="cart-drawer" [class.open]="cartService.isOpen()">
  <div class="header">
    <h2>Your Cart ({{ cartService.count() }})</h2>
    <button class="close-btn" (click)="close()">×</button>
  </div>

  <div class="items">
    <div class="cart-item" *ngFor="let item of cartService.items()">
      <img [src]="item.image" [alt]="item.name" />
      <div class="info">
        <h4>{{ item.name }}</h4>
        <div class="price">{{ item.price | currency }}</div>

        <div class="controls">
          <button (click)="decrement(item)">-</button>
          <span>{{ item.quantity }}</span>
          <button (click)="increment(item)">+</button>
        </div>
      </div>
      <button class="remove-btn" (click)="remove(item)" title="Remove">×</button>
    </div>

    <div class="empty-msg" *ngIf="cartService.count() === 0">Your cart is empty.</div>
  </div>

  <div class="footer">
    <div class="total">
      <span>Subtotal</span>
      <span>{{ cartService.subtotal() | currency }}</span>
    </div>
    <app-button
      variant="primary"
      [fullWidth]="true"
      [disabled]="cartService.count() === 0"
      (onClick)="checkout()"
    >
      Proceed to Checkout
    </app-button>
  </div>
</div>
